module.exports = __webpack_public_path__ + "img/icon_map_2_on_010.320d1d99.png";